import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Crown, Sparkles, MessageSquare, Calendar, Wand2, ArrowUpRight, X } from "lucide-react";

const FEATURES = [
  {
    icon: Wand2,
    title: "3 idee storia ogni mattina alle 9:00",
    body:
      "Ricevi su Telegram tre idee concrete da pubblicare oggi, calibrate sul tuo posizionamento e sulla tua città.",
  },
  {
    icon: Sparkles,
    title: "Caption + hashtag illimitati",
    body:
      "Scrivi il post in 3 secondi: l'AI usa il tuo brand per testi sempre coerenti, niente più \"frasi da social\".",
  },
  {
    icon: Calendar,
    title: "Programmazione automatica multi-canale",
    body:
      "Mandi il grezzo (foto, video, vocali). Pensiamo noi a tagli, sottotitoli, musica e pubblicazione su Instagram, Facebook, TikTok, YouTube e Google.",
  },
  {
    icon: MessageSquare,
    title: "Chat 1-a-1 con il tuo team",
    body:
      "Niente WhatsApp incasinati: una linea diretta, ordinata, dove tutto resta archiviato e ritrovabile.",
  },
];

/**
 * Pro info dialog: explains what the Pro plan is and offers a single CTA
 * to book a free consultation. Stateless: parent controls open + handles
 * "request consultation" callback.
 */
export default function ProInfoDialog({ open, onOpenChange, onRequestConsultation }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="pro-info-dialog"
        className="max-w-2xl rounded-3xl border-2 border-[var(--mp-ink)] p-0 overflow-hidden gap-0 shadow-brutal"
      >
        <div className="bg-[var(--mp-ink)] text-white px-6 py-7 sm:px-8">
          <DialogHeader className="space-y-2">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-[var(--mp-yellow)] text-[var(--mp-ink)] grid place-items-center border border-[var(--mp-yellow)]">
                <Crown className="h-5 w-5" />
              </div>
              <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-[var(--mp-yellow)]">
                Piano Pro
              </div>
            </div>
            <DialogTitle className="font-display text-3xl sm:text-4xl tracking-tighter text-white">
              Facciamo noi il 95% del lavoro.
            </DialogTitle>
            <DialogDescription className="text-white/80 text-sm leading-relaxed">
              Il Pro è il piano in cui smetti di pensare ai social. Tu mandi il
              grezzo, noi confezioniamo, programmiamo e pubblichiamo ogni giorno
              su tutti i canali. Niente burocrazia di idee, montaggio, hashtag
              e calendario editoriale.
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="bg-white px-6 py-6 sm:px-8 space-y-4 max-h-[60vh] overflow-y-auto">
          <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--mp-muted)]">
            Cosa è incluso
          </div>
          <ul className="grid sm:grid-cols-2 gap-3">
            {FEATURES.map((f) => (
              <li
                key={f.title}
                className="rounded-2xl border border-[var(--mp-border)] bg-[var(--mp-dash-bg)] p-4 flex gap-3 items-start"
              >
                <div className="h-9 w-9 rounded-full bg-[var(--mp-yellow)] grid place-items-center shrink-0 border border-[var(--mp-ink)]">
                  <f.icon className="h-4 w-4" />
                </div>
                <div>
                  <div className="font-display text-sm leading-tight">
                    {f.title}
                  </div>
                  <p className="mt-1 text-xs text-[var(--mp-muted)] leading-relaxed">
                    {f.body}
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <div className="rounded-2xl bg-[var(--mp-yellow)] border border-[var(--mp-ink)] p-4 text-sm leading-relaxed">
            <strong>Come si attiva?</strong> Prenoti una consulenza gratuita,
            capiamo insieme se è il piano giusto per te e dopo la chiamata
            attiviamo tutto in 24h. Nessun impegno: la consulenza è davvero
            gratis.
          </div>
        </div>

        <div className="bg-white px-6 py-5 sm:px-8 flex items-center justify-end gap-2 border-t border-[var(--mp-border)] flex-wrap">
          <Button
            variant="ghost"
            onClick={() => onOpenChange?.(false)}
            data-testid="pro-info-close"
            className="rounded-full"
          >
            <X className="h-4 w-4 mr-1" /> Chiudi
          </Button>
          <a
            href="https://www.nicobenz.it/prenota"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onOpenChange?.(false)}
            data-testid="pro-info-consult"
            className="inline-flex items-center gap-1.5 rounded-full bg-[var(--mp-ink)] hover:bg-black text-white h-10 px-5 text-sm font-semibold"
          >
            <Sparkles className="h-4 w-4" />
            Richiedi consulenza gratuita
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
